export enum ProxyType {
  General = 1,
  ForDelivery = 2,
}
